import { render, staticRenderFns } from "./tireDetailDialog.vue?vue&type=template&id=2148c322&scoped=true&"
import script from "./tireDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./tireDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./tireDetailDialog.vue?vue&type=style&index=0&id=2148c322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2148c322",
  null
  
)

export default component.exports